import LastIcon from './component'

export default LastIcon
